<div class="h-full w-full">
    @if(!isChildRouteActive) {
    <div class="flex flex-1 flex-col h-full w-full gap-2 p-3">
        <!-- Top Bar -->
        <div class="flex items-center gap-3">
            @if(active && canCreateProjects) {
            <app-button variant="filled" severity="primary" icon="pi pi-plus" iconPosition="left"
                (clicked)="openProjectDialog()" [label]="'Create project'" />
            }
            <div class="w-[25%]">
                <app-search-bar placeholder="{{'Search with project / customer name'}}" [(ngModel)]="projectSearchValue"
                    (searchChange)="onProjectSearch()" width="100%"></app-search-bar>
            </div>

            <div class="flex items-center gap-2 ml-auto text-sm">
                <!-- View Toggle -->
                <app-select-button [options]="viewModeOptions" [(ngModel)]="viewMode"
                    (selectionChange)="onViewModeChange($event)" size="small">
                </app-select-button>

                <!-- Sort -->
                <app-sort-popover [fields]="sortFields" [(sortField)]="sortField" [(sortOrder)]="sortOrder"
                    (sortChange)="sortProjects()" />


                <!-- Filter -->
                <app-button variant="outlined" severity="contrast" icon="pi pi-filter" iconPosition="left"
                    (clicked)="toggleFilterPanel()" [label]="'Filters'" />
            </div>
        </div>



        <!-- Projects List/Grid -->
        <div class="flex-1 min-h-0 flex flex-col h-full">
            <ng-container *ngIf="!tableConfig.loading && projects.length === 0; else dataBlock">
                <div class="w-full flex justify-center h-full flex-1 items-center">

                    <div class="flex flex-col w-[25%] text-center">
                        @if(!canCreateProjects && !hasActiveFilters) {
                        <span class="text-xl font-bold">{{'No Projects Assigned to you Yet' | titlecase}}</span>
                        }@else {
                        @if(hasActiveFilters) {
                        <span class="text-xl font-bold">{{'No projects found' | titlecase}}</span>
                        <span>{{'No projects match your current filter criteria.' | titlecase}}</span>
                        }@else if(active) {
                        <span class="text-xl font-bold">{{'Create your first project' | titlecase}}</span>
                        <span>{{'Projects help you organize and track progress. Add a project to start streamlining your
                            workflow and collaboration.' | titlecase}}</span>
                        <div class="mt-4">
                            <app-button label="{{'Create Project' | titlecase}}" severity="primary" icon="pi pi-plus"
                                variant="filled" (clicked)="openProjectDialog()" />
                        </div>
                        }@else {
                        <span class="text-xl font-bold">{{'No archived projects' | titlecase}}</span>
                        <!-- <span>No archived projects found.</span> -->
                        }
                        }
                    </div>
                </div>
            </ng-container>

            <ng-template #dataBlock>
                <app-grid-list-view [items]="projects" [viewMode]="viewMode" [gridItemTemplate]="gridItemTemplate"
                    [dataKey]="'_id'" [scrollable]="true" [rows]="rows" [rowsPerPageOptions]="[20, 30, 40]"
                    [useDataTable]="viewMode === 'list'" [tableColumns]="tableColumns" [tableConfig]="tableConfig"
                    [customTemplates]="templatesMap" [totalRecords]="totalRecords" [first]="first"
                    [showPaginator]="true" (pageChange)="onPageChange($event)"
                    [parentClass]="'flex-1 flex flex-col min-h-0'"
                    [itemsLoading]="tableConfig.loading || false"></app-grid-list-view>

                <!-- Grid Item Template -->
                <ng-template #gridItemTemplate let-project>
                    <div class="rounded-base border border-gray-200 shadow-sm flex flex-col cursor-pointer hover:shadow-md transition w-full h-full overflow-hidden"
                        (click)="navigateToProject(project._id, !active)">
                        <div class="p-3 flex flex-col gap-2 flex-1 justify-between">
                            <div class="flex flex-col gap-2">
                                <div class="flex justify-between items-start">

                                    <div class="flex items-center gap-2">
                                        @if(project.status) {
                                        <div
                                            class="rounded-base px-2 py-1 flex items-center justify-center truncate max-w-[6.25rem] theme-text-border">
                                            <span class="theme-text text-xs font-medium">
                                                {{ getStatus(project.status) }}
                                            </span>
                                        </div>
                                        }
                                    </div>

                                    <div class="flex items-center gap-2">
                                        <div class="flex items-center gap-2 text-sm font-medium text-gray-700">
                                            <div class="progress-circle" [style.--progress]="project.progress + '%'"
                                                [style.--progress-color]="getProgressColor(project.progress)"></div>
                                            <span>{{ project.progress }}%</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-sm font-semibold text-gray-900 truncate-2-lines"
                                    [pTooltip]="project.name" pTooltip="{{project.name}}" tooltipPosition="bottom">
                                    {{ project.name }}
                                </div>
                            </div>

                            @if($any(project).upcomingMilestone?.length > 0) {
                            <div class="flex items-center gap-1 text-xs text-gray-600 min-w-0">
                                <i class="pi pi-flag text-arena-orange-500 flex-shrink-0"></i>

                                <span class="truncate min-w-0"
                                    [pTooltip]="'Upcoming milestone: ' + $any(project).upcomingMilestone[0].name"
                                    tooltipPosition="bottom">
                                    {{ $any(project).upcomingMilestone[0].name }}
                                </span>

                                <span class="text-gray-400 flex-shrink-0">•</span>

                                <span
                                    class="rounded-base bg-arena-orange-100 text-arena-orange py-1 px-2 whitespace-nowrap flex-shrink-0"
                                    [pTooltip]="'Upcoming milestone date: ' + ($any(project).upcomingMilestone[0].date | date: 'MMM d, YYYY')"
                                    tooltipPosition="bottom">
                                    {{ $any(project).upcomingMilestone[0].date | date: 'MMM d' }}
                                </span>
                            </div>
                            } @else {
                            <div class="text-xs text-gray-400 italic flex items-center gap-1">
                                <i class="pi pi-flag"></i>
                                <span>No upcoming milestones</span>
                            </div>
                            }

                            <div class="flex flex-row flex-wrap justify-between items-center gap-2">
                                <div class="flex items-center gap-1 min-w-0 flex-1">
                                    <i class="pi pi-user text-arena-blue icon-xs flex-shrink-0"></i>
                                    <span class="text-xs text-gray-700 truncate min-w-0"
                                        [pTooltip]="'Customer: ' + (getCustomerName(project.customer) || 'No Customer')"
                                        tooltipPosition="bottom">
                                        {{ getCustomerName(project.customer) || 'No Customer' }}
                                    </span>
                                </div>

                                <div class="flex items-center flex-shrink-0">
                                    <app-avatar-stack [users]="$any(project.managers)" [visibleAvatars]="2" size="xs" />
                                </div>
                            </div>

                        </div>

                        <div class="flex items-center gap-2 pt-2 pb-3 px-3 text-xs border-t text-gray-500">
                            <span class="text-gray-400">
                                Created
                                <span class="text-gray-700">
                                    {{ project.createdAt | date: 'dd MMM yyyy' }}
                                </span>
                            </span>

                            @if(project.dueDate) {
                            <span class="font-semibold text-gray-300">•</span>

                            <span class="text-gray-400">
                                Due
                                <span class="text-gray-700">
                                    {{ project.dueDate | date: 'dd MMM yyyy' }}
                                </span>
                            </span>
                            }
                        </div>

                    </div>
                </ng-template>

                <!-- List Header Template -->
                <ng-template #listHeaderTemplate>
                    <div
                        class="bg-gray-50 text-xs font-semibold text-gray-600 border w-full grid grid-cols-8 gap-4 items-center p-3">
                        <div>{{'Project Name' | titlecase}}</div>
                        <div>{{'Project Manager' | titlecase}}</div>
                        <div>Customer/Prospect</div>
                        <div>Progress</div>
                        <div>{{'Upcoming Milestone' | titlecase}}</div>
                        <div>{{'Date Created' | titlecase}}</div>
                        <div>Status</div>
                        <div>{{'Due Date' | titlecase}}</div>
                        <div>{{'Actions' | titlecase}}</div>
                    </div>
                </ng-template>

                <!-- List Row Template -->
                <ng-template #listRowTemplate let-project>
                    <div class="grid grid-cols-8 gap-4 items-center text-sm p-3 hover:bg-gray-50 cursor-pointer"
                        (click)="navigateToProject(project._id, !active)">
                        <div class="font-medium text-sm text-gray-800">{{ project.name }}</div>
                        <div class="flex items-center gap-2 text-sm">
                            @for(manager of project.managers; track manager._id) {
                            {{ getManagerName(manager) }}
                            }
                        </div>
                        <div class="text-sm">{{ getCustomerName(project.customer) || '-' }}</div>
                        <div class="flex items-center gap-2">
                            <div class="w-full h-2 bg-blue-100 rounded-full">
                                <div class="h-2 rounded-full bg-blue-400" [ngStyle]="{ width: project.progress + '%' }">
                                </div>
                            </div>
                            <span class="text-xs text-gray-500">{{ project.progress }}%</span>
                        </div>
                        <div class="text-sm text-gray-600">{{ project.createdAt | date: 'dd MMM yyyy' }}</div>
                        <div>
                            @if(project.status) {
                            <div [ngClass]="getStatusColor(project.status)"
                                class="px-2 py-1 rounded-base text-center flex items-center">
                                <span class="text-xs font-medium">{{ getStatus(project.status) }}</span>
                            </div>
                            }
                        </div>
                        <div class="text-sm text-gray-600">{{ project.dueDate | date: 'dd MMM yyyy' }}</div>
                        <div class="flex justify-end" (click)="$event.stopPropagation()">
                            @if(canCreateProjects) {
                            <app-project-actions-menu [project]="project" (edit)="openEditProject($event)"
                                (delete)="openDeleteDialog($event)" />
                            }
                        </div>
                    </div>
                </ng-template>
            </ng-template>
        </div>


        <!-- Data Table Templates -->
        <!-- Project Name Template -->
        <ng-template #projectNameTemplateRef let-project="$implicit">
            <div class="flex items-center gap-2 cursor-pointer hover:bg-gray-50 -mx-2 px-2 py-1 rounded transition-all"
                (click)="navigateToProject(project._id, !active)">
                <div class="flex-1 flex items-center gap-1">
                    <div
                        class="font-medium text-gray-900 hover:text-arena-orange transition-colors truncate max-w-[14rem]">
                        {{project.name}}
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- Customer Template -->
        <ng-template #customerTemplateRef let-project="$implicit">
            <div class="text-sm text-gray-700 truncate max-w-[10rem]">
                {{ getCustomerName(project.customer) || ('No customer' | titlecase) }}
            </div>
        </ng-template>

        <!-- Upcoming Milestone Template -->
        <ng-template #upcomingMilestoneTemplateRef let-project="$implicit">
            <div class="text-sm">
                @if(project.upcomingMilestone.length > 0){
                <div class="flex items-center gap-2">
                    <span class="text-gray-700 truncate" [title]="project.upcomingMilestone[0].name">
                        {{project.upcomingMilestone[0].name}}
                    </span>
                    <span class="text-gray-400">•</span>
                    <span
                        class="rounded-base bg-arena-orange-100 text-arena-orange px-2 py-1 text-xs font-medium whitespace-nowrap">
                        {{ project.upcomingMilestone[0].date | date: 'MMM d' }}
                    </span>
                </div>
                }@else {
                <span class="text-xs text-gray-400 italic">No upcoming milestone</span>
                }
            </div>
        </ng-template>

        <!-- Manager Template -->
        <ng-template #managerTemplateRef let-project="$implicit">
            <div class="flex items-center">
                <app-avatar-stack [users]="project.managers" [visibleAvatars]="2" size="xs">
                </app-avatar-stack>
            </div>
        </ng-template>

        <!-- Status Template -->
        <ng-template #statusTemplateRef let-project="$implicit">
            @if(project.status) {
            <div class="rounded-base px-2 py-1 inline-flex items-center justify-center theme-text-border w-fit">
                <span class="theme-text text-xs font-medium whitespace-nowrap">{{ getStatus(project.status) }}</span>
            </div>
            }
        </ng-template>

        <!-- Due Date Template -->
        <ng-template #dueDateTemplateRef let-project="$implicit">
            <div class="text-sm"
                [ngClass]="{'text-danger font-semibold': project.dueDateExceeding, 'font-light': !project.dueDateExceeding}">
                {{project.dueDate | date: 'dd MMM yyyy' }}
            </div>
        </ng-template>

        <!-- Date Created Template -->
        <ng-template #dateCreatedTemplateRef let-project="$implicit">
            <div class="text-sm font-light">{{ project.createdAt | date: 'dd MMM yyyy' }}</div>
        </ng-template>

        <!-- Actions Template (table view) -->
        <ng-template #actionsTemplateRef let-project="$implicit">
            <div class="flex justify-end" (click)="$event.stopPropagation()">
                @if(canCreateProjects) {
                <app-project-actions-menu [project]="project" (edit)="openEditProject($event)"
                    (delete)="openDeleteDialog($event)" />
                }
            </div>
        </ng-template>

    </div>

    <!-- Create/Edit Project Dialog with Stepper -->
    <app-project-form-dialog [(visible)]="projectDialogVisible" [mode]="editProjectId ? 'edit' : 'create'"
        [projectFormData]="projectFormData" [projectId]="editProjectId || ''" [managerOptions]="managerOptions"
        (hide)="resetProjectDialog(); editProjectId = null"
        (submit)="editProjectId ? onUpdateProject($event) : onCreateProject($event)" [permissions]="permissions"
        [shareDetails]="shareDetails"
        [submitLoading]="editProjectId ? isUpdateProjectLoading() : isCreateProjectLoading()">
    </app-project-form-dialog>

    @if(displayDeleteDialog && projectToDelete) {
    <app-delete-confirmation [(visible)]="displayDeleteDialog" confirmButtonText="Yes, delete"
        [requireConfirmation]="true"
        [headerText]="'Delete ' + projectToDelete.name + ' ' + (projectToDelete.active ? 'Project' : 'Project Permanently') + ' ?'"
        [bodyText]="'Deleting this project will  ' + (projectToDelete.active ? 'archive' : 'permanently deletes') + ' all associated project documents and project knowledge.'"
        (onConfirm)="confirmDeleteProject()" [closable]="false">
        <ng-template #zipDownloadTemplate>
            <div class="flex flex-col font-semibold sm:flex-row sm:items-center sm:justify-between gap-3 py-2">
                <p class="text-sm text-gray-700">Download ZIP containing project documents and project knowledge</p>
                <app-button variant="outlined" severity="contrast" label="Download ZIP" (clicked)="downloadZIP()"
                    [loading]="isDownloadingZIP()" class="w-full sm:w-auto flex-shrink-0" />
            </div>
        </ng-template>
    </app-delete-confirmation>
    }

    }
    @else {
    <router-outlet></router-outlet>
    }
</div>



<!-- Filter Panel -->
@if(filterPanelVisible) {
<p-drawer [(visible)]="filterPanelVisible" position="right" class="w-[22rem]">
    <ng-template pTemplate="headless">
        <div class="flex flex-col h-full">
            <div class="flex items-center justify-between border-b p-4">
                <h2 class="text-lg font-semibold">Filter</h2>
                <app-button icon="pi pi-times" (clicked)="toggleFilterPanel(true)" variant="filled"
                    severity="contrast" />
            </div>
            <div class="flex-1 overflow-y-auto space-y-5 text-sm text-gray-800 p-4">
                <div>
                    <label class="block font-medium mb-1">{{'Project name'}}</label>
                    <input pInputText [(ngModel)]="filterProjectName" class="w-full p-2 border rounded-base"
                        placeholder="{{'Enter project name'}}" [style]="{ outline: 'none' }" />
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Project manager'}}</label>
                    <app-multi-select [(value)]="filterManager" [options]="managerOptions" optionLabel="label"
                        optionValue="value" [config]="{filter: true, searchPlaceholder: 'Search People',
                            placeholder: 'Select manager', panelStyleClass: 'max-h-48 overflow-y-auto',
                            styleClass: 'w-full border border-gray-300 rounded-base'}"></app-multi-select>
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Customer / prospect name'}}</label>
                    <input pInputText [(ngModel)]="filterCustomerName" placeholder="{{'Enter customer'}}"
                        class="w-full name p-2 border rounded-base" [style]="{ outline: 'none' }" />
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Due date'}}</label>
                    <app-datepicker [(value)]="filterDueDateRange" [config]="{
                        selectionMode: 'range',
                        showIcon: true,
                        dateFormat: 'dd M yy',
                        placeholder: 'Select Due Date',
                    }" />
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Date created'}}</label>
                    <app-datepicker [(value)]="filterCreatedDateRange" [config]="{
                        selectionMode: 'range',
                        showIcon: true,
                        dateFormat: 'dd M yy',
                        placeholder: 'Select Created Date',
                    }" />
                </div>
            </div>
            <div class="flex justify-between items-center px-6 py-4 border-t gap-2">
                <app-button label="{{'Clear all'}}" (clicked)="clearAllFilters()" variant="outlined" severity="contrast"
                    class="flex-1 w-full" />
                <app-button label="{{'Apply'}}" (clicked)="applyFilters()" variant="filled" severity="primary"
                    class="flex-1 w-full" />
            </div>
        </div>
    </ng-template>
</p-drawer>
}